'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

type Props = {
  targetId: string
  url: string
}

const TagSearchEvent = ({ targetId, url }: Props) => {
  const router = useRouter()

  useEffect(() => {
    const element = document.getElementById(targetId)
    const ac = new AbortController()

    if (element) {
      element.addEventListener('click', () => {
        router.push(url)
      })
    }

    return () => ac.abort()
  }, [targetId])

  return null
}

export default TagSearchEvent
